"use client";
import copy from "~/redesign/content/chatbot-copy.json";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import dialogImgTr from "~/assets/images/chatbotPage/dialog-tr.png?url";
import dialogImg from "~/assets/images/chatbotPage/dialog.png?url";
import heroContentImg1Tr from "~/assets/images/chatbotPage/hero-content-img1-tr.png?url";
import heroContentImg1 from "~/assets/images/chatbotPage/hero-content-img1.png?url";
import Image from "~/common/components/CustomImage";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import styles from "./ChatbotSection1.module.scss";

const ChatbotSection1 = ({ locale, title, description }) => {
  const { t } = useTranslation();
  const c = copy[locale === "tr" ? "tr" : "en"];

  return (
    <div className={clsx(styles.chatbotSection1, "card")}>
      <div className={styles.chatbotSection1Content}>
        <div className={styles.chatbotSection1ContentLeft}>
          <h1 className={clsx("pal-section-title", styles.chatbotSection1Title)} title={title ?? t("chatbot.section1.title")}>{title ?? t("chatbot.section1.title")}</h1>
          <p className={clsx("pal-section-desc", styles.chatbotSection1Desc)}>{description ?? t("chatbot.section1.description")}</p>
          <PricingOfferButton source="chatbot-section-1" />
        </div>
        <div className={styles.chatbotSection1ContentRight}>
          <Image
            src={locale === "tr" ? heroContentImg1Tr : heroContentImg1}
            alt={t("chatbot.section1.heroImageAlt")}
            width={485}
            height={586}
          />
        </div>
      </div>

      <div className={styles.chatbotSection1Content2}>
        <h2 className={styles.chatbotSection1Content2Title}>{c.secondaryTitle}</h2>
        <p className={styles.chatbotSection1Content2Desc}>{c.secondaryDescription}</p>
        <div className={styles.chatbotSection1Content2Dialog}>
          <Image
            src={locale === "tr" ? dialogImgTr : dialogImg}
            alt={t("chatbot.section1.dialogImageAlt")}
            width={1312}
            height={460}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatbotSection1;
